import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  categories: [],
  singleCategory: [],
};

const slice = createSlice({
  name: "category",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    startFetchLoading(state) {
      state.fetchLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
      state.fetchLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // TODO: successFetch blog

    getCategorySuccess(state, action) {
      state.fetchLoading = false;
      state.categories = action.payload;
    },

    postCategorySuccess(state, action) {
      state.isLoading = false;
      state.categories = [action.payload, ...state.categories];
    },

    // TODO: single blog fetch success

    getSingleCategorySucess(state, action) {
      state.fetchLoading = false;
      state.singleCategory = action.payload;
    },

    // Update category
    updateCategorySuccess(state, action) {
      state.isLoading = false;
    },

    // delete category
    deleteCategorySuccess(state, action) {
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

export function getCategories() {
  return async (dispatch) => {
    dispatch(slice.actions.startFetchLoading());
    try {
      const response = await axios.get(`categories`);
      dispatch(slice.actions.getCategorySuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function postCategories({
  category_id,
  name,
  enqueueSnackbar,
  onClose,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`categories`, {
        category_id,
        name,
      });
      dispatch(slice.actions.postCategorySuccess(response.data.data));
      onClose && onClose();
    } catch (error) {
      enqueueSnackbar(error.message || "error", {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCategory({ category_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startFetchLoading());
    try {
      const response = await axios.get(`categories`, {
        params: {
          category_id,
        },
      });
      dispatch(slice.actions.getSingleCategorySucess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteCategory({ id, enqueueSnackbar, category_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`categories/${id}`);
      dispatch(getCategory({ category_id }));
      dispatch(slice.actions.deleteCategorySuccess());
      enqueueSnackbar("category deleted successfully.");
    } catch (error) {
      enqueueSnackbar(
        JSON.stringify(error.message || "Error deleting category", {
          variant: "error",
        })
      );
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateCategory({
  id,
  name,
  enqueueSnackbar,
  category_id,
  onClose,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.patch(`categories/${id}`, { name });
      dispatch(getCategory({ category_id }));
      enqueueSnackbar("category updated successfully.");
      dispatch(slice.actions.stopLoading());
      onClose && onClose();
    } catch (error) {
      enqueueSnackbar(
        JSON.stringify(error.message || "Error deleting category", {
          variant: "error",
        })
      );
      dispatch(slice.actions.hasError(error));
    }
  };
}
